'use strict';

import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import bootMobileNav from './mobile-nav.jsx';
import Menus from "./Menus.jsx";
import SearchMenu from './SearchMenu.jsx';

jQuery($ => {
	bootMobileNav($);
	
	const swiftype_engine = $('meta[name=swiftype-engine]').attr('content');
	
	// Boot main menu for frontend if it's present
	const target_element = document.getElementById('navbar--dynamic-menus');
	if (target_element) {
		// Flush synchronously so the static menus are only hidden once the dynamic menus are in the DOM
		flushSync(() => createRoot(target_element).render(
			<Menus
				menus={ $('.nav-dropdown') }
				admin_content={ $('#navbar--admin-content').html() }
				article_key={ $('meta[name=internachi-article]').attr('content') }
				csrf={ 'csrfToken' in window ? window.csrfToken : $('meta[name=csrf-token]').attr('content') }
				swiftype_engine={ swiftype_engine }
				current_url={ window.location.href }
			/>
		));
		$('#navbar--static-menus').attr('class', 'hidden');
	} else {
		// Otherwise, try search-only menu for dashboard
		const search_element = document.getElementById('navbar--search-menu');
		if (search_element) {
			createRoot(search_element).render(<SearchMenu engine={ swiftype_engine } />);
		}
	}
});
